import React from "react";
import { Check } from "lucide-react";
import { HERO, OFFER, DIRECT_BOOKING } from "../mock";
import { QuizForm } from "./QuizForm";
import { InlineScheduler } from "./InlineScheduler";
import { SectionEyebrow } from "./common";

export const Hero = ({ onComplete }) => (
  <section className="relative overflow-hidden bg-brand-ivory">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 pb-16 pt-12 md:px-8 lg:grid-cols-2 lg:gap-14 lg:pb-24 lg:pt-16">
      {/* Left column */}
      <div className="animate-fade-up">
        <SectionEyebrow>{HERO.eyebrow}</SectionEyebrow>
        <h1 className="mt-6 font-serif text-[42px] font-semibold leading-[1.05] text-brand-ink md:text-6xl">
          {HERO.titleA}{" "}
          <span className="block font-serif italic text-brand-gold">{HERO.titleItalic}</span>
        </h1>
        <p className="mt-6 font-serif text-xl text-brand-ink md:text-2xl">
          {HERO.priceLine}{" "}
          <span className="font-semibold text-brand-sage">${OFFER.price}</span>{" "}
          <span className="text-brand-muted line-through decoration-brand-muted/60">${OFFER.regPrice}</span>
        </p>
        <p className="mt-4 max-w-md font-display text-lg italic leading-relaxed text-brand-muted">
          {HERO.subtitle}
        </p>
        <ul className="mt-7 space-y-3">
          {HERO.bullets.map((b) => (
            <li key={b} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-brand-sage">
                <Check size={13} className="text-white" />
              </span>
              <span className="font-sans text-[15px] text-brand-ink">{b}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Right column - image + floating form on desktop */}
      <div className="relative animate-fade-up" style={{ animationDelay: "120ms" }}>
        <div className="overflow-hidden rounded-3xl shadow-[0_40px_90px_-40px_rgba(35,35,32,0.55)]">
          <img src={HERO.image} alt="Aesthetician performing a non-surgical face lift" className="h-[340px] w-full object-cover md:h-[560px]" />
        </div>
        <div className="mt-8 lg:mt-8">
          {DIRECT_BOOKING ? <InlineScheduler /> : <QuizForm onComplete={onComplete} />}
        </div>
      </div>
    </div>
  </section>
);
